import { put, call, take, takeLatest } from 'redux-saga/effects'
import { makeSaga } from './util'

import { postEffect, putEffect } from './network'
import { types, actions } from '../reducers/resetPassword'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * resetPasswordRequestEffect ({ email }) {
  const request = {
    url: 'reset-password', // POST
    options: {
      body: {
        email
      }
    }
  }
  const chan = yield call(postEffect, request)
  return yield take(chan)
}

export function * resetPasswordConfirmEffect ({ token, password }) {
  const request = {
    url: 'reset-password', // PUT
    options: {
      body: {
        token,
        password
      }
    }
  }
  const chan = yield call(putEffect, request)
  return yield take(chan)
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

/**
 * takeLatest(types.SUBMIT_REQUEST, resetPasswordRequestFlow)
 */
export function * resetPasswordRequestFlow ({ payload }) {
  const result = yield call(resetPasswordRequestEffect, payload)

  if (result.error) {
    yield put(actions.submitError(result))
  } else {
    yield put(actions.submitSuccess(result))
  }
}

/**
 * takeLatest(types.SUBMIT_REQUEST, resetPasswordConfirmFlow)
 */
export function * resetPasswordConfirmFlow ({ payload }) {
  const result = yield call(resetPasswordConfirmEffect, payload)

  if (result.error) {
    yield put(actions.confirmError(result))
  } else {
    yield put(actions.confirmSuccess(result))
  }
}

export default makeSaga([
  takeLatest(types.SUBMIT_REQUEST, resetPasswordRequestFlow),
  takeLatest(types.CONFIRM_REQUEST, resetPasswordConfirmFlow)
])
